// removed by extract-text-webpack-plugin
module.exports = {"mask":"mask___V4LVT","container":"container___Y-CSa","product-title":"product-title___3NYen","stock-list-wrapper":"stock-list-wrapper___3TH4_","stock-list":"stock-list___37vE8","stock-message":"stock-message___3zoJF"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/stock/styles.module.scss
// module id = 469
// module chunks = 0